/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ACSApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `ACSModule.forRoot()`
 */
export interface ACSApiConfigurationParams {
  rootUrl?: string;
}
